import { render, staticRenderFns } from "./PartnerEditForm.vue?vue&type=template&id=59511736&"
import script from "./PartnerEditForm.vue?vue&type=script&lang=ts&"
export * from "./PartnerEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports